var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8697 2.56917C19.4186 1.41751 18.3752 0.146848 17.1387 0.462277L2.0281 4.30736C0.787555 4.6234 0.482188 6.24386 1.52155 6.99054L5.91478 10.1447L10.4826 6.3934C10.6889 6.22989 10.9512 6.15395 11.2129 6.18195C11.4747 6.20995 11.7149 6.33964 11.882 6.54308C12.0491 6.74653 12.1295 7.00745 12.1061 7.26966C12.0826 7.53187 11.9572 7.77439 11.7567 7.94497L7.18885 11.6963L9.42919 16.6194C9.95844 17.784 11.6074 17.7986 12.1585 16.6442L18.8697 2.56917Z",
    fill: "#DBE8FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.17e8d3e200de15c9a04c1e9b995f0a36.svg";
export { ForwardRef as ReactComponent };